import React, { useState, useEffect } from 'react';
import { getPvConsumptionDisplayFields } from '../../utils/pvConsumptionQualification';
import { getTerminDetails, cancelTermin, updateTermin, getUsersByOrganization, getLeadOrganizationId, updateLeadProperties, getBewertung, addDummyEmail } from '../../api';
import { useNavigate } from 'react-router-dom';
import BewertungDialog from '../common/BewertungDialog';

function TerminDetailDialog({ termin, user, onClose, onNavigateToCustomer, onTerminDeleted }) {
  const [terminDetails, setTerminDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showCancelDialog, setShowCancelDialog] = useState(false);
  const [showUpdateDialog, setShowUpdateDialog] = useState(false);
  const [showAssignDialog, setShowAssignDialog] = useState(false);
  const [stornierungsgrund, setStornierungsgrund] = useState('');
  const [cancelling, setCancelling] = useState(false);
  const [updating, setUpdating] = useState(false);
  const [assigning, setAssigning] = useState(false);
  const [newDate, setNewDate] = useState('');
  const [newTime, setNewTime] = useState('');
  const [newDuration, setNewDuration] = useState(termin.dauer || 60);
  const [selectedMitarbeiter, setSelectedMitarbeiter] = useState('');
  const [mitarbeiter, setMitarbeiter] = useState([]);
  const [loadingMitarbeiter, setLoadingMitarbeiter] = useState(false);
  const [productToRate, setProductToRate] = useState(null);
  const [bewertungLoading, setBewertungLoading] = useState(false);
  const [bewertungData, setBewertungData] = useState(null);
  const [bewertungError, setBewertungError] = useState('');
  const [addingDummyEmail, setAddingDummyEmail] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    loadTerminDetails();
  }, [termin.id]);

  useEffect(() => {
    if (terminDetails?.kunde_id) {
      loadBewertungData();
    }
  }, [terminDetails?.kunde_id]);

  const loadTerminDetails = async () => {
    setLoading(true);
    setError('');

    try {
      // Versuche zuerst die spezielle API
      const response = await getTerminDetails(user.id, termin.id);

      if (response.success) {
        setTerminDetails(response.termin);
      } else {
        setError(response.error || 'Fehler beim Laden der Termin-Details');
      }
    } catch (err) {
      console.warn('getTerminDetails nicht verfügbar, verwende Basis-Termin-Daten:', err);
      // Fallback: Verwende die bereits verfügbaren Termin-Daten
      setTerminDetails({
        ...termin,
        kunde_name: termin.kunde_name || 'Unbekannter Kunde',
        kunde_nachname: termin.kunde_nachname || '',
        mitarbeiter_name: termin.mitarbeiter_name || 'Kein Berater zugewiesen',
        adresse: termin.adresse || '',
        notizen: termin.notizen || '',
        kommentare: [], // Leer, da nicht verfügbar
        status: termin.status || 'Geplant',
        pv_data: null,
        wp_data: null,
        produkt: null
      });
    } finally {
      setLoading(false);
    }
  };

  const loadMitarbeiter = async () => {
    setLoadingMitarbeiter(true);
    setError('');

    try {
      // Immer nur mit user.id aufrufen (ohne organization_id)
      const response = await getUsersByOrganization(user.id);
      if (response.success) {
        // Nur Fachberater (role_type 6) anzeigen
        const fachberater = response.users.filter(mitarbeiter => mitarbeiter.role_type === 6);
        setMitarbeiter(fachberater);
      } else {
        setError('Fehler beim Laden der Fachberater: ' + response.error);
      }
    } catch (err) {
      setError('Fehler beim Laden der Fachberater: ' + err.message);
    } finally {
      setLoadingMitarbeiter(false);
    }
  };

  const loadBewertungData = async () => {
    if (!terminDetails?.kunde_id) return;

    setBewertungLoading(true);
    setBewertungError('');

    try {
      const response = await getBewertung(user.id, terminDetails.kunde_id);
      if (response.success) {
        setBewertungData(response.bewertung);
      } else {
        setBewertungError(response.error || 'Fehler beim Laden der Bewertungsdaten');
      }
    } catch (err) {
      setBewertungError('Fehler beim Laden der Bewertungsdaten: ' + err.message);
    } finally {
      setBewertungLoading(false);
    }
  };

  console.log("terminDetails : ", terminDetails);

  const getCustomerUrl = async () => {
    if (!terminDetails?.kunde_id) return null;

    try {
      // Organisation-ID des Leads ermitteln
      const orgResponse = await getLeadOrganizationId(user.id, terminDetails.kunde_id);

      if (orgResponse.success) {
        const leadOrgId = orgResponse.organizationId;

        if (user?.isOrgLeader || user?.roleType === 3) {
          return `/organization-leads/${leadOrgId}/${terminDetails.kunde_id}`;
        } else if (user?.isCallcenterLeader || user?.isCallcenterMitarbeiter || user?.roleType === 4 || user?.roleType === 5) {
          return `/customer/${terminDetails.kunde_id}`;
        }
      } else {
        // Fallback: Verwende die alte Navigation
        if (user?.isOrgLeader || user?.roleType === 3) {
          return `/organization-leads/${terminDetails.kunde_id}`;
        } else if (user?.isCallcenterLeader || user?.isCallcenterMitarbeiter || user?.roleType === 4 || user?.roleType === 5) {
          return `/customer/${terminDetails.kunde_id}`;
        }
      }
    } catch (err) {
      console.error('Fehler beim Laden der Lead-Organisation:', err);
      // Fallback: Verwende die alte Navigation
      if (user?.isOrgLeader || user?.roleType === 3) {
        return `/organization-leads/${terminDetails.kunde_id}`;
      } else if (user?.isCallcenterLeader || user?.isCallcenterMitarbeiter || user?.roleType === 4 || user?.roleType === 5) {
        return `/customer/${terminDetails.kunde_id}`;
      }
    }
    return null;
  };

  const handleCustomerClick = async (e) => {
    e.preventDefault();
    const url = await getCustomerUrl();
    if (url) {
      window.open(url, '_blank');
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('de-DE', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const formatTime = (timeString) => {
    return timeString.substring(0, 5);
  };

  const calculateEndTime = (startTime, duration) => {
    if (!startTime || !duration) return '';

    const [hours, minutes] = startTime.split(':').map(Number);
    const durationMinutes = parseInt(duration);

    const startDate = new Date();
    startDate.setHours(hours, minutes, 0, 0);

    const endDate = new Date(startDate.getTime() + durationMinutes * 60000);

    return endDate.toLocaleTimeString('de-DE', {
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const renderPvData = (pvData) => {
    if (!pvData) return null;

    const pvConsumptionDisplay = getPvConsumptionDisplayFields(pvData);

    return (
      <div className="detail-section">
        <h3>☀️ PV-Anlagen Daten</h3>
        <div className="detail-grid">
          <div className="detail-item">
            <span className="detail-label">Eigentümer:</span>
            <span className="detail-value">{pvData.eigentumer || 'Nicht angegeben'}</span>
          </div>
          <div className="detail-item">
            <span className="detail-label">Gebäudeart:</span>
            <span className="detail-value">{pvData.gebaudeart || 'Nicht angegeben'}</span>
          </div>
          <div className="detail-item">
            <span className="detail-label">Dachfläche über 20 qm:</span>
            <span className="detail-value">{pvData.dachflache_20_qm || 'Nicht angegeben'}</span>
          </div>
          <div className="detail-item">
            <span className="detail-label">Dachfläche:</span>
            <span className="detail-value">{pvData.dachflache || 'Nicht angegeben'}</span>
          </div>
          <div className="detail-item">
            <span className="detail-label">Dachausrichtung:</span>
            <span className="detail-value">{pvData.dachausrichtung || 'Nicht angegeben'}</span>
          </div>
          <div className="detail-item">
            <span className="detail-label">Denkmalschutz:</span>
            <span className="detail-value">{pvData.denkmalschutz || 'Nicht angegeben'}</span>
          </div>
          <div className="detail-item">
            <span className="detail-label">kWh-Verbrauch &gt; 2700?</span>
            <span className="detail-value">{pvConsumptionDisplay.verbrauchUeber2700 || 'Nicht angegeben'}</span>
          </div>
          <div className="detail-item">
            <span className="detail-label">kWh 2300–2700 – Realisierung in 3 Monaten?</span>
            <span className="detail-value">{pvConsumptionDisplay.verbrauch2300_2700_3Monate || 'Nicht angegeben'}</span>
          </div>
          <div className="detail-item">
            <span className="detail-label">Jahresverbrauch (kWh):</span>
            <span className="detail-value">{pvData.jahresverbrauch || 'Nicht angegeben'}</span>
          </div>
          <div className="detail-item">
            <span className="detail-label">Asbest vorhanden:</span>
            <span className="detail-value">{pvData.asbest || 'Nicht angegeben'}</span>
          </div>
          <div className="detail-item">
            <span className="detail-label">Zukünftige Energieabnehmer:</span>
            <span className="detail-value">{pvData.zukuenftige_energie_abnehmer || 'Nicht angegeben'}</span>
          </div>
          {pvData.alternative_montage === 'Ja' && (
            <>
              <div className="detail-item">
                <span className="detail-label">Alternative Montage:</span>
                <span className="detail-value">{pvData.alternative_montage}</span>
              </div>
              <div className="detail-item">
                <span className="detail-label">Alternative Montagefläche:</span>
                <span className="detail-value">{pvData.alternative_montage_flaeche || 'Nicht angegeben'}</span>
              </div>
            </>
          )}
          <div className="detail-item">
            <span className="detail-label">Opt-In Status:</span>
            <span className={`detail-value ${pvData.status_opt_in === 'Bestätigt' ? 'status-confirmed' : 'status-pending'}`}>
              {pvData.status_opt_in || 'Nicht bestätigt'}
            </span>
          </div>
        </div>
      </div>
    );
  };

  const renderWpData = (wpData) => {
    if (!wpData) return null;

    return (
      <div className="detail-section">
        <h3>🔥 Wärmepumpen Daten</h3>
        <div className="detail-grid">
          <div className="detail-item">
            <span className="detail-label">Eigentümer:</span>
            <span className="detail-value">{wpData.eigentumer || 'Nicht angegeben'}</span>
          </div>
          <div className="detail-item">
            <span className="detail-label">Gebäudeart:</span>
            <span className="detail-value">{wpData.gebaudeart || 'Nicht angegeben'}</span>
          </div>
          <div className="detail-item">
            <span className="detail-label">Wohnfläche:</span>
            <span className="detail-value">{wpData.wohnflache || 'Nicht angegeben'}</span>
          </div>
          <div className="detail-item">
            <span className="detail-label">Personen im Haushalt:</span>
            <span className="detail-value">{wpData.personen || 'Nicht angegeben'}</span>
          </div>
          <div className="detail-item">
            <span className="detail-label">Baujahr:</span>
            <span className="detail-value">{wpData.baujahr || 'Nicht angegeben'}</span>
          </div>
          <div className="detail-item">
            <span className="detail-label">Gas oder Öl vorhanden:</span>
            <span className="detail-value">{wpData.gas_oder_oel || 'Nicht angegeben'}</span>
          </div>
          <div className="detail-item">
            <span className="detail-label">Heizung älter als 2 Jahre:</span>
            <span className="detail-value">{wpData.heizung_alter_2 || 'Nicht angegeben'}</span>
          </div>
          <div className="detail-item">
            <span className="detail-label">Wärmeabgabesystem:</span>
            <span className="detail-value">{wpData.waermeabgabesystem || 'Nicht angegeben'}</span>
          </div>
          <div className="detail-item">
            <span className="detail-label">Solarthermie vorhanden:</span>
            <span className="detail-value">{wpData.solarthermie || 'Nicht angegeben'}</span>
          </div>
          {wpData.solarthermie === 'Ja' && (
            <div className="detail-item">
              <span className="detail-label">Solarthermie Abbau möglich:</span>
              <span className="detail-value">{wpData.solarthermie_abbau || 'Nicht angegeben'}</span>
            </div>
          )}
          <div className="detail-item">
            <span className="detail-label">Denkmalschutz:</span>
            <span className="detail-value">{wpData.denkmalschutz || 'Nicht angegeben'}</span>
          </div>
          <div className="detail-item">
            <span className="detail-label">Opt-In Status:</span>
            <span className={`detail-value ${wpData.status_opt_in === 'Bestätigt' ? 'status-confirmed' : 'status-pending'}`}>
              {wpData.status_opt_in || 'Nicht bestätigt'}
            </span>
          </div>
        </div>
      </div>
    );
  };

  const hasProductData = () => {
    return terminDetails && (terminDetails.pv_data || terminDetails.wp_data);
  };

  const handleCancelTermin = async () => {
    if (!stornierungsgrund.trim()) {
      setError('Bitte geben Sie einen Grund für die Stornierung an.');
      return;
    }

    setCancelling(true);
    setError('');

    try {
      const response = await cancelTermin(user.id, termin.id, stornierungsgrund);

      if (response.success) {
        // Dialog schließen und Parent-Komponente benachrichtigen
        if (onTerminDeleted) {
          onTerminDeleted(termin.id);
        }
        onClose();
      } else {
        setError(response.error || 'Fehler beim Stornieren des Termins');
      }
    } catch (err) {
      setError('Netzwerkfehler: ' + err.message);
    } finally {
      setCancelling(false);
      setShowCancelDialog(false);
    }
  };

  const handleUpdateTermin = async () => {
    if (!newDate || !newTime) {
      setError('Bitte wählen Sie ein neues Datum und eine neue Uhrzeit aus.');
      return;
    }

    setUpdating(true);
    setError('');

    try {
      const response = await updateTermin(user.id, termin.id, {
        datum: newDate,
        uhrzeit: newTime,
        dauer: newDuration
      });

      if (response.success) {
        await loadTerminDetails(); // Lade die aktualisierten Details neu
        setShowUpdateDialog(false);
      } else {
        setError(response.error || 'Fehler beim Aktualisieren des Termins');
      }
    } catch (err) {
      setError('Netzwerkfehler: ' + err.message);
    } finally {
      setUpdating(false);
    }
  };

  const handleAssignMitarbeiter = async () => {
    if (!selectedMitarbeiter) {
      setError('Bitte wählen Sie einen Fachberater aus.');
      return;
    }

    setAssigning(true);
    setError('');

    try {
      const selectedMitarbeiterData = mitarbeiter.find(m => m.id.toString() === selectedMitarbeiter);

      const response = await updateTermin(user.id, termin.id, {
        mitarbeiter_id: parseInt(selectedMitarbeiter),
        mitarbeiter_name: selectedMitarbeiterData.full_name,
        mitarbeiter_team_id: selectedMitarbeiterData.team_id
      });

      if (response.success) {
        await loadTerminDetails(); // Lade die aktualisierten Details neu
        setShowAssignDialog(false);
        setSelectedMitarbeiter('');
      } else {
        setError(response.error || 'Fehler beim Zuweisen des Fachberaters');
      }
    } catch (err) {
      setError('Netzwerkfehler: ' + err.message);
    } finally {
      setAssigning(false);
    }
  };

  const handleSaveBewertung = async ({ status, notiz }) => {
    if (!terminDetails?.kunde_id || !productToRate) {
      setError('Kunden-ID oder zu bewertendes Produkt nicht gefunden.');
      return;
    }
    setBewertungLoading(true);
    setError('');

    try {
      const productType = productToRate;

      // Fachberater dürfen nur bewertung_status setzen, nicht den eigentlichen status
      const updateData = {
        bewertung_status: status,
        bewertung_notiz: notiz,
        bewertet_von: user.full_name,
        bewertet_am: new Date().toISOString().slice(0, 19).replace('T', ' '),
      };

      // Nur Callcenter-Mitarbeiter und Admins dürfen den eigentlichen Status ändern
      if (user?.isCallcenterLeader || user?.isCallcenterMitarbeiter || user?.isAdmin || user?.isOrgLeader) {
        updateData.status = status;
      }

      const response = await updateLeadProperties(user.id, terminDetails.kunde_id, productType, updateData);

      if (response.success) {
        setProductToRate(null);
        await loadTerminDetails();
      } else {
        setError(response.error || 'Fehler beim Speichern der Bewertung.');
      }
    } catch (err) {
      setError('Netzwerkfehler: ' + err.message);
    } finally {
      setBewertungLoading(false);
    }
  };

  const openAssignDialog = () => {
    setSelectedMitarbeiter('');
    setError('');
    loadMitarbeiter();
    setShowAssignDialog(true);
  };

  const handleAddDummyEmail = async () => {
    if (!terminDetails?.kunde_name || !terminDetails?.kunde_id) {
      setError('Kundenname oder Kunden-ID nicht verfügbar.');
      return;
    }

    // Bestätigung einholen
    if (!window.confirm(`Möchten Sie wirklich eine Dummy-E-Mail für ${terminDetails.kunde_name} hinzufügen?`)) {
      return;
    }

    setAddingDummyEmail(true);
    setError('');

    try {
      let vorname = '';
      let nachname = '';

      // Verwende separate Namen falls verfügbar, sonst teile kunde_name auf
      if (terminDetails.kunde_nachname) {
        // Separate Namen verfügbar - verwende sie direkt
        vorname = terminDetails.kunde_name || '';
        nachname = terminDetails.kunde_nachname || '';
      } else {
        // Fallback: Namen aufteilen - nimmt den vollen Namen und teilt bei Leerzeichen
        const nameParts = terminDetails.kunde_name.trim().split(/\s+/).filter(part => part.length > 0);

        if (nameParts.length === 0) {
          setError('Ungültiger Kundenname');
          setAddingDummyEmail(false);
          return;
        } else if (nameParts.length === 1) {
          // Nur ein Name vorhanden - verwende ihn für beide Teile
          vorname = nameParts[0];
          nachname = nameParts[0];
        } else {
          // Mehrere Namensteile: Erster = Vorname, Rest = Nachname (zusammengefügt)
          // Beispiel: "Max Mustermann" → max.mustermann@keinemail.de
          // Beispiel: "Hans Peter Müller" → hans.petermueller@keinemail.de
          vorname = nameParts[0];
          nachname = nameParts.slice(1).join('');
        }
      }

      // Namen für E-Mail-Adresse bereinigen (Umlaute ersetzen, Sonderzeichen entfernen, Kleinbuchstaben)
      const cleanName = (name) => {
        return name
          .toLowerCase()
          .replace(/ä/g, 'ae')
          .replace(/ö/g, 'oe')
          .replace(/ü/g, 'ue')
          .replace(/ß/g, 'ss')
          .replace(/[^a-z]/g, '');
      };

      const vornameClean = cleanName(vorname);
      const nachnameClean = cleanName(nachname);

      // Debug-Ausgabe für bessere Nachvollziehbarkeit
      console.log('Original Name:', terminDetails.kunde_name);
      console.log('Separate Nachname verfügbar:', !!terminDetails.kunde_nachname);
      console.log('Vorname:', vorname, '→', vornameClean);
      console.log('Nachname:', nachname, '→', nachnameClean);
      console.log('E-Mail wird:', vornameClean + '.' + nachnameClean + '@keinemail.de');

      const response = await addDummyEmail(user.id, terminDetails.kunde_id, vornameClean, nachnameClean);

      if (response.success) {
        await loadTerminDetails(); // Details neu laden
      } else {
        setError(response.error || 'Fehler beim Hinzufügen der Dummy-E-Mail');
      }
    } catch (err) {
      setError('Netzwerkfehler: ' + err.message);
    } finally {
      setAddingDummyEmail(false);
    }
  };

  console.log(user);


  console.log("Das hier sind die Termin-Details: ", terminDetails);

  return (
    <div
      className="modal-overlay"
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          onClose();
        }
      }}
    >
      <div className="modal-dialog large">
        <div className="modal-header">
          <h2>Termin-Details</h2>
          <button className="close-button" onClick={onClose}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        <div className="modal-content">
          {loading ? (
            <div className="loading-center">
              <div className="loading-spinner"></div>
              <span>Lade Termin-Details...</span>
            </div>
          ) : error ? (
            <div className="error-message">{error}</div>
          ) : terminDetails ? (
            <div className="termin-details">
              {/* Zeitbereich */}
              <div className="detail-section">
                <h3>📅 Terminzeit</h3>
                <div className="detail-grid">
                  <div className="detail-item">
                    <span className="detail-label">Datum:</span>
                    <span className="detail-value">{formatDate(terminDetails.datum)}</span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">Uhrzeit:</span>
                    <span className="detail-value">
                      {formatTime(terminDetails.uhrzeit)}
                      {terminDetails.dauer && (
                        <span className="time-range">
                          {' '} - {calculateEndTime(terminDetails.uhrzeit, terminDetails.dauer)}
                          {' '}({terminDetails.dauer} Min.)
                        </span>
                      )}
                    </span>
                  </div>
                </div>
              </div>

              {/* Kundeninformationen */}
              <div className="detail-section">
                <h3>👤 Kunde</h3>
                <div className="detail-grid">
                  <div className="detail-item">
                    <span className="detail-label">Name:</span>
                    {terminDetails.kunde_id && !user?.isFachberater ? (
                      <a
                        href="#"
                        className="detail-value customer-link"
                        onClick={handleCustomerClick}
                        title="Klicken für Kundendetails"
                      >
                        {terminDetails.kunde_name}
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <path d="M7 17L17 7"></path>
                          <path d="M7 7h10v10"></path>
                        </svg>
                      </a>
                    ) : (
                      <span className="detail-value">{terminDetails.kunde_name}</span>
                    )}
                  </div>
                  {terminDetails.kunde_email && (
                    <div className="detail-item">
                      <span className="detail-label">E-Mail:</span>
                      <span className="detail-value">
                        <a href={`mailto:${terminDetails.kunde_email}`}>
                          {terminDetails.kunde_email}
                        </a>
                      </span>
                    </div>
                  )}
                  {terminDetails.kunde_telefon && (
                    <div className="detail-item">
                      <span className="detail-label">Telefon:</span>
                      <span className="detail-value">
                        <a href={`tel:${terminDetails.kunde_telefon}`}>
                          {terminDetails.kunde_telefon}
                        </a>
                      </span>
                    </div>
                  )}
                  {terminDetails.produkt && (
                    <div className="detail-item">
                      <span className="detail-label">Produkt:</span>
                      <span className="detail-value product-badge">
                        {terminDetails.produkt}
                      </span>
                    </div>
                  )}
                </div>
              </div>

              {/* Adresse */}
              {terminDetails.adresse && (
                <div className="detail-section">
                  <h3>📍 Adresse</h3>
                  <div className="detail-grid">
                    <div className="detail-item full-width">
                      <span className="detail-value address">
                        {terminDetails.adresse}
                        <a
                          href={`https://maps.google.com?q=${encodeURIComponent(terminDetails.adresse)}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="maps-link"
                          title="In Google Maps öffnen"
                        >
                          🗺️ Maps
                        </a>
                      </span>
                    </div>
                  </div>
                </div>
              )}

              {/* PV-Daten */}
              {terminDetails.pv_data && renderPvData(terminDetails.pv_data)}

              {/* WP-Daten */}
              {terminDetails.wp_data && renderWpData(terminDetails.wp_data)}

              {/* Wenn keine Produktdaten vorhanden sind */}
              {!hasProductData() && terminDetails.kunde_id && (
                <div className="detail-section">
                  <h3>📋 Produktdaten</h3>
                  <div className="no-product-data">
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1">
                      <circle cx="12" cy="12" r="10"></circle>
                      <path d="M8 14s1.5 2 4 2 4-2 4-2"></path>
                      <line x1="9" y1="9" x2="9.01" y2="9"></line>
                      <line x1="15" y1="9" x2="15.01" y2="9"></line>
                    </svg>
                    <p>Keine detaillierten Produktdaten verfügbar</p>
                    <span>Möglicherweise wurden noch keine PV- oder WP-Eigenschaften erfasst</span>
                  </div>
                </div>
              )}
              {/* Backoffice-Kommentar */}
              {terminDetails?.kunde_id && (
                <div className="detail-section">
                  <h3>Backoffice-Kommentar</h3>
                  <div className="bo-comment-section">
                    {terminDetails.bo_kommentar ? (
                      <div className="bo-comment-content">{terminDetails.bo_kommentar}</div>
                    ) : (
                      <div className="no-data">Kein Backoffice-Kommentar vorhanden</div>
                    )}
                  </div>
                </div>
              )}
              {/* Bewertungen */}
              {terminDetails?.kunde_id && (
                <div className="detail-section">
                  <h3>Bewertungen</h3>
                  <div className="detail-grid">
                    {bewertungLoading ? (
                      <div className="detail-item full-width">
                        <div className="loading-text">Lade Bewertungsdaten...</div>
                      </div>
                    ) : bewertungError ? (
                      <div className="detail-item full-width">
                        <div className="error-text">{bewertungError}</div>
                      </div>
                    ) : bewertungData ? (
                      <>
                        <div className="detail-item">
                          <span className="detail-label">Status:</span>
                          <span className={`detail-value status-badge ${bewertungData.bewertung_status?.toLowerCase() || 'unbekannt'}`}>
                            {bewertungData.bewertung_status || 'Nicht bewertet'}
                          </span>
                        </div>
                        <div className="detail-item">
                          <span className="detail-label">Bewertet am:</span>
                          <span className="detail-value">
                            {bewertungData.bewertet_am ? new Date(bewertungData.bewertet_am).toLocaleString('de-DE') : 'Nicht verfügbar'}
                          </span>
                        </div>
                        {bewertungData.bewertung_notiz && (
                          <div className="detail-item full-width">
                            <span className="detail-label">Bewertungsnotiz:</span>
                            <div className="notizen-text">
                              {bewertungData.bewertung_notiz}
                            </div>
                          </div>
                        )}
                      </>
                    ) : (
                      <div className="detail-item full-width">
                        <div className="no-data">Keine Bewertungsdaten verfügbar</div>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* Notizen */}
              {terminDetails.notizen && (
                <div className="detail-section">
                  <h3>📝 Notizen</h3>
                  <div className="detail-grid">
                    <div className="detail-item full-width">
                      <div className="notizen-text">
                        {terminDetails.notizen}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Status */}
              <div className="detail-section">
                <h3>ℹ️ Status</h3>
                <div className="detail-grid">
                  <div className="detail-item">
                    <span className="detail-label">Status:</span>
                    <span className={`detail-value status-badge ${terminDetails.status?.toLowerCase() || 'geplant'}`}>
                      {terminDetails.status || 'Geplant'}
                    </span>
                  </div>
                  {terminDetails.mitarbeiter_name && (
                    <div className="detail-item">
                      <span className="detail-label">Zugewiesen an:</span>
                      <span className="detail-value">{terminDetails.mitarbeiter_name}</span>
                    </div>
                  )}
                </div>
              </div>

              {/* Stornierungsstatus anzeigen */}
              {terminDetails && terminDetails.status === 'storniert' && (
                <div className="detail-section cancelled-section">
                  <h3>❌ Termin storniert</h3>
                  <div className="detail-grid">
                    <div className="detail-item">
                      <span className="detail-label">Grund:</span>
                      <span className="detail-value">{terminDetails.stornierungsgrund}</span>
                    </div>
                    <div className="detail-item">
                      <span className="detail-label">Storniert am:</span>
                      <span className="detail-value">
                        {terminDetails.storniert_am ? new Date(terminDetails.storniert_am).toLocaleString('de-DE') : '-'}
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div className="no-data">Keine Termin-Details verfügbar</div>
          )}
        </div>

        <div className="modal-actions">
          {terminDetails && terminDetails.status !== 'storniert' && (
            <>
              {/* Fachberater zuweisen Button - nur für Organisationsleiter */}
              {user?.isOrgLeader && (
                <button
                  className="assign-berater-button"
                  onClick={openAssignDialog}
                  disabled={assigning}
                >
                  Fachberater zuweisen
                </button>
              )}

              {/* Termin ändern Button - nur für Callcenter */}
              {(user?.isCallcenterLeader || user?.isCallcenterMitarbeiter) && (
                <button
                  className="update-termin-button"
                  onClick={() => {
                    setNewDate(terminDetails.datum);
                    setNewTime(terminDetails.uhrzeit);
                    setShowUpdateDialog(true);
                  }}
                  disabled={updating}
                >
                  Termin ändern
                </button>
              )}

              {/* Terminbewertung Buttons - nur für Fachberater */}
              {user?.isFachberater && terminDetails?.produkt?.toLowerCase().includes('pv') && !terminDetails?.pv_data?.bewertung_status && (
                <button
                  className="bewertung-button pv"
                  onClick={() => setProductToRate('PV')}
                  disabled={bewertungLoading}
                >
                  PV bewerten
                </button>
              )}
              {user?.isFachberater && terminDetails?.produkt?.toLowerCase().includes('wp') && !terminDetails?.wp_data?.bewertung_status && (
                <button
                  className="bewertung-button wp"
                  onClick={() => setProductToRate('WP')}
                  disabled={bewertungLoading}
                >
                  WP bewerten
                </button>
              )}

              {/* Termin stornieren Button - nur für Callcenter */}
              {(user?.isCallcenterLeader || user?.isCallcenterMitarbeiter) && (
                <button
                  className="cancel-termin-button"
                  onClick={() => setShowCancelDialog(true)}
                  disabled={cancelling}
                >
                  Termin stornieren
                </button>
              )}

              {/* Dummy E-Mail hinzufügen Button - nur für Callcenter Leader */}
              {user?.isCallcenterLeader && terminDetails?.kunde_id && (
                <button
                  className="add-dummy-email-button"
                  onClick={handleAddDummyEmail}
                  disabled={addingDummyEmail}
                >
                  {addingDummyEmail ? 'Wird hinzugefügt...' : 'Dummy E-Mail hinzufügen'}
                </button>
              )}
            </>
          )}
          <button className="close-button" onClick={onClose}>
            Schließen
          </button>
        </div>

        {/* Bewertungs-Dialog */}
        {productToRate && (
          <BewertungDialog
            onSave={handleSaveBewertung}
            onCancel={() => setProductToRate(null)}
            loading={bewertungLoading}
          />
        )}

        {/* Stornierungs-Dialog */}
        {showCancelDialog && (
          <div
            className="modal-overlay"
            onClick={(e) => {
              if (e.target === e.currentTarget) {
                setShowCancelDialog(false);
              }
            }}
          >
            <div className="modal-dialog">
              <div className="modal-header">
                <h3>Termin stornieren</h3>
                <button className="close-button" onClick={() => setShowCancelDialog(false)}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </button>
              </div>
              <div className="modal-content">
                <div className="form-group">
                  <label htmlFor="stornierungsgrund">Grund der Stornierung:</label>
                  <textarea
                    id="stornierungsgrund"
                    value={stornierungsgrund}
                    onChange={(e) => setStornierungsgrund(e.target.value)}
                    placeholder="Bitte geben Sie den Grund für die Stornierung an..."
                    rows={4}
                    required
                  />
                </div>
                <div className="modal-actions">
                  <button
                    className="cancel-button"
                    onClick={() => setShowCancelDialog(false)}
                    disabled={cancelling}
                  >
                    Abbrechen
                  </button>
                  <button
                    className="confirm-button"
                    onClick={handleCancelTermin}
                    disabled={cancelling || !stornierungsgrund.trim()}
                  >
                    {cancelling ? 'Wird storniert...' : 'Termin stornieren'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Update Termin Dialog */}
        {showUpdateDialog && (
          <div
            className="modal-overlay"
            onClick={(e) => {
              if (e.target === e.currentTarget) {
                setShowUpdateDialog(false);
              }
            }}
          >
            <div className="modal-dialog">
              <div className="modal-header">
                <h3>Termin ändern</h3>
                <button className="close-button" onClick={() => setShowUpdateDialog(false)}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </button>
              </div>
              <div className="modal-content">
                <div className="form-group">
                  <label htmlFor="newDate">Neues Datum:</label>
                  <input
                    type="date"
                    id="newDate"
                    value={newDate}
                    onChange={(e) => setNewDate(e.target.value)}
                    min={new Date().toISOString().split('T')[0]}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="newTime">Neue Uhrzeit:</label>
                  <input
                    type="time"
                    id="newTime"
                    value={newTime}
                    onChange={(e) => setNewTime(e.target.value)}
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="newDuration">Dauer (in Minuten):</label>
                  <select
                    id="newDuration"
                    value={newDuration}
                    onChange={(e) => setNewDuration(Number(e.target.value))}
                  >
                    <option value="15">15 Minuten</option>
                    <option value="30">30 Minuten</option>
                    <option value="45">45 Minuten</option>
                    <option value="60">1 Stunde</option>
                    <option value="75">1:15 Stunden</option>
                    <option value="90">1:30 Stunden</option>
                    <option value="105">1:45 Stunden</option>
                    <option value="120">2 Stunden</option>
                    <option value="135">2:15 Stunden</option>
                    <option value="150">2:30 Stunden</option>
                    <option value="165">2:45 Stunden</option>
                    <option value="180">3 Stunden</option>
                  </select>
                </div>
                <div className="modal-actions">
                  <button
                    className="cancel-button"
                    onClick={() => setShowUpdateDialog(false)}
                    disabled={updating}
                  >
                    Abbrechen
                  </button>
                  <button
                    className="confirm-button update"
                    onClick={handleUpdateTermin}
                    disabled={updating || !newDate || !newTime}
                  >
                    {updating ? 'Wird aktualisiert...' : 'Termin aktualisieren'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Fachberater zuweisen Dialog */}
        {showAssignDialog && (
          <div
            className="modal-overlay"
            onClick={(e) => {
              if (e.target === e.currentTarget) {
                setShowAssignDialog(false);
              }
            }}
          >
            <div className="modal-dialog">
              <div className="modal-header">
                <h3>Fachberater zuweisen</h3>
                <button className="close-button" onClick={() => setShowAssignDialog(false)}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </button>
              </div>
              <div className="modal-content">
                {loadingMitarbeiter ? (
                  <div className="loading-center">
                    <div className="loading-spinner"></div>
                    <span>Lade Fachberater...</span>
                  </div>
                ) : (
                  <div className="form-group">
                    <label htmlFor="selectedMitarbeiter">Fachberater auswählen:</label>
                    <select
                      id="selectedMitarbeiter"
                      value={selectedMitarbeiter}
                      onChange={(e) => setSelectedMitarbeiter(e.target.value)}
                      required
                    >
                      <option value="">Bitte wählen Sie einen Fachberater...</option>
                      {mitarbeiter.map((m) => (
                        <option key={m.id} value={m.id}>
                          {m.full_name} {m.team_name ? `(${m.team_name})` : ''}
                        </option>
                      ))}
                    </select>
                    {mitarbeiter.length === 0 && (
                      <p className="no-berater-message">
                        Keine Fachberater in Ihrer Organisation verfügbar.
                      </p>
                    )}
                  </div>
                )}
                <div className="modal-actions">
                  <button
                    className="cancel-button"
                    onClick={() => setShowAssignDialog(false)}
                    disabled={assigning}
                  >
                    Abbrechen
                  </button>
                  <button
                    className="confirm-button assign"
                    onClick={handleAssignMitarbeiter}
                    disabled={assigning || !selectedMitarbeiter || mitarbeiter.length === 0}
                  >
                    {assigning ? 'Wird zugewiesen...' : 'Fachberater zuweisen'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      <style jsx>{`
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
          padding: 20px;
        }

        .modal-dialog.large {
          background: white;
          border-radius: 12px;
          max-width: 800px;
          width: 100%;
          max-height: 90vh;
          overflow: hidden;
          display: flex;
          flex-direction: column;
          box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
        }

        .modal-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 20px 24px;
          border-bottom: 1px solid #e2e8f0;
          background: #f8fafc;
        }

        .modal-header h2 {
          margin: 0;
          color: #2d3748;
          font-size: 1.5rem;
        }

        .close-button {
          background: none;
          border: none;
          cursor: pointer;
          color: #718096;
          padding: 4px;
          border-radius: 4px;
          transition: all 0.2s;
        }

        .close-button:hover {
          background: #e2e8f0;
          color: #2d3748;
        }

        .modal-content {
          flex: 1;
          overflow-y: auto;
          padding: 24px;
        }

        .loading-center {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 40px;
          gap: 12px;
          color: #718096;
        }

        .loading-spinner {
          width: 32px;
          height: 32px;
          border: 3px solid #e2e8f0;
          border-top: 3px solid #4a6de5;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        .termin-details {
          display: flex;
          flex-direction: column;
          gap: 24px;
        }

        .detail-section {
          background: #f8fafc;
          border-radius: 8px;
          padding: 20px;
          border: 1px solid #e2e8f0;
        }

        .detail-section h3 {
          margin: 0 0 16px 0;
          color: #2d3748;
          font-size: 1.1rem;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .detail-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 16px;
        }

        .detail-item {
          display: flex;
          flex-direction: column;
          gap: 4px;
        }

        .detail-item.full-width {
          grid-column: 1 / -1;
        }

        .detail-label {
          font-weight: 600;
          color: #4a5568;
          font-size: 0.9rem;
        }

        .detail-value {
          color: #2d3748;
          font-size: 1rem;
        }

        .customer-link {
          color: #4a6de5;
          cursor: pointer;
          text-decoration: underline;
          display: flex;
          align-items: center;
          gap: 4px;
          transition: color 0.2s;
        }

        .customer-link:hover {
          color: #3c5ce0;
        }

        .time-range {
          color: #718096;
          font-size: 0.9rem;
        }

        .address {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .maps-link {
          color: #4a6de5;
          text-decoration: none;
          padding: 4px 8px;
          border-radius: 4px;
          transition: all 0.2s;
          font-size: 0.9rem;
        }

        .maps-link:hover {
          background: #ebf4ff;
          color: #3c5ce0;
        }

        .product-badge {
          display: inline-block;
          background: #4a6de5;
          color: white;
          padding: 4px 12px;
          border-radius: 20px;
          font-size: 0.85rem;
          font-weight: 600;
          text-transform: uppercase;
        }

        .status-confirmed {
          color: #059669;
          font-weight: 600;
        }

        .status-pending {
          color: #d97706;
          font-weight: 600;
        }

        .no-product-data {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 40px;
          color: #a0aec0;
          text-align: center;
        }

        .no-product-data svg {
          margin-bottom: 16px;
          opacity: 0.6;
        }

        .no-product-data p {
          margin: 0 0 8px 0;
          font-size: 1.1rem;
          font-weight: 500;
        }

        .no-product-data span {
          font-size: 0.9rem;
          font-style: italic;
        }

        .bo-comment-section {
          background: #f8fafc;
          border-radius: 8px;
          padding: 20px;
          border: 1px solid #e2e8f0;
        }

        .bo-comment-content {
          color: #2d3748;
          font-size: 1rem;
        }

        .no-data {
          text-align: center;
          color: #718096;
          padding: 40px;
          font-style: italic;
        }

        .cancelled-section {
          background-color: #fff5f5;
          border: 1px solid #fed7d7;
          border-radius: 8px;
          padding: 15px;
          margin-top: 20px;
        }

        .cancelled-section h3 {
          color: #e53e3e;
          margin-top: 0;
        }

        .assign-berater-button {
          background-color: #38a169;
          color: white;
          padding: 0.5rem 1rem;
          border-radius: 0.375rem;
          border: none;
          cursor: pointer;
          font-weight: 500;
          margin-right: 0.5rem;
        }

        .assign-berater-button:hover {
          background-color: #2f855a;
        }

        .assign-berater-button:disabled {
          background-color: #9ae6b4;
          cursor: not-allowed;
        }

        .cancel-termin-button {
          background-color: #e53e3e;
          color: white;
          padding: 0.5rem 1rem;
          border-radius: 0.375rem;
          border: none;
          cursor: pointer;
          font-weight: 500;
        }

        .cancel-termin-button:hover {
          background-color: #c53030;
        }

        .cancel-termin-button:disabled {
          background-color: #fc8181;
          cursor: not-allowed;
        }

        .form-group {
          margin-bottom: 1rem;
        }

        .form-group label {
          display: block;
          margin-bottom: 0.5rem;
          font-weight: 500;
        }

        .form-group textarea {
          width: 100%;
          padding: 0.5rem;
          border: 1px solid #e2e8f0;
          border-radius: 0.375rem;
          resize: vertical;
        }

        .form-group select {
          width: 100%;
          padding: 0.5rem;
          border: 1px solid #e2e8f0;
          border-radius: 0.375rem;
          font-size: 1rem;
        }

        .confirm-button {
          background-color: #e53e3e;
          color: white;
        }

        .confirm-button:hover {
          background-color: #c53030;
        }

        .confirm-button:disabled {
          background-color: #fc8181;
          cursor: not-allowed;
        }

        .update-termin-button {
          background-color: #4a6de5;
          color: white;
          padding: 0.5rem 1rem;
          border-radius: 0.375rem;
          border: none;
          cursor: pointer;
          font-weight: 500;
          margin-right: 0.5rem;
        }

        .update-termin-button:hover {
          background-color: #3c5ce0;
        }

        .update-termin-button:disabled {
          background-color: #a0aec0;
          cursor: not-allowed;
        }

        .form-group input[type="date"],
        .form-group input[type="time"] {
          width: 100%;
          padding: 0.5rem;
          border: 1px solid #e2e8f0;
          border-radius: 0.375rem;
          font-size: 1rem;
        }

        .confirm-button.update {
          background-color: #4a6de5;
        }

        .confirm-button.update:hover {
          background-color: #3c5ce0;
        }

        .confirm-button.update:disabled {
          background-color: #a0aec0;
          cursor: not-allowed;
        }

        .confirm-button.assign {
          background-color: #38a169;
        }

        .confirm-button.assign:hover {
          background-color: #2f855a;
        }

        .confirm-button.assign:disabled {
          background-color: #9ae6b4;
          cursor: not-allowed;
        }

        .no-berater-message {
          color: #718096;
          font-style: italic;
          margin-top: 0.5rem;
        }

        .bewertung-button:disabled {
          background-color: #a0aec0;
          cursor: not-allowed;
        }

        .bewertung-button.pv {
          background-color: #dd6b20; /* Orange für PV */
        }
        .bewertung-button.pv:hover {
          background-color: #c05621;
        }

        .bewertung-button.wp {
          background-color: #3182ce; /* Blau für WP */
        }
        .bewertung-button.wp:hover {
          background-color: #2b6cb0;
        }

        .add-dummy-email-button {
          background-color: #805ad5; /* Lila für Dummy-E-Mail */
          color: white;
          padding: 0.5rem 1rem;
          border-radius: 0.375rem;
          border: none;
          cursor: pointer;
          font-weight: 500;
          margin-right: 0.5rem;
        }

        .add-dummy-email-button:hover {
          background-color: #6b46c1;
        }

        .add-dummy-email-button:disabled {
          background-color: #d6bcfa;
          cursor: not-allowed;
        }

        @media (max-width: 768px) {
          .modal-dialog.large {
            max-width: 95%;
            margin: 10px;
          }

          .modal-header {
            padding: 16px 20px;
          }

          .modal-header h2 {
            font-size: 1.25rem;
          }

          .modal-content {
            padding: 20px;
          }

          .detail-section {
            padding: 16px;
          }

          .detail-grid {
            grid-template-columns: 1fr;
            gap: 12px;
          }

          .termin-details {
            gap: 20px;
          }

          .modal-actions {
            padding: 16px 20px;
          }
        }

        @media (max-width: 480px) {
          .modal-overlay {
            padding: 10px;
          }

          .modal-dialog.large {
            max-width: 100%;
            max-height: 95vh;
          }

          .modal-header {
            padding: 12px 16px;
          }

          .modal-content {
            padding: 16px;
          }

          .detail-section {
            padding: 12px;
          }

          .detail-section h3 {
            font-size: 1rem;
          }

          .modal-actions {
            padding: 12px 16px;
          }
        }
      `}</style>
    </div>
  );
}

export default TerminDetailDialog;